import lodashCloneDeep from 'lodash/cloneDeep'

export function resetProxy (initialObj: any, proxy: any): void {
  const resetObj = lodashCloneDeep(initialObj)
  // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
  Object.keys(resetObj).forEach((key) => {
    proxy[key] = resetObj[key]
  })
}
